import React from 'react';
import RoutingSettingsPage from './RoutingSettingsPage';

// The shared routing form in create mode (VCC or Direct Bill, from the rule) — see RoutingSettingsPage.
const AddRoutingPage = () => <RoutingSettingsPage mode="create" />;

export default AddRoutingPage;
